import { createFileRoute } from '@tanstack/react-router';
import { PackagePortal } from '@/features/package-sharing/components/package-portal';
import { QueryClientProvider } from '@tanstack/react-query';
import { publicPackageQuery, publicQueryClient } from '@/features/package-sharing/queries';
import { t } from '@/features/i18n/utils';

export const Route = createFileRoute('/p/$token')({
  loader: ({ params }) => publicQueryClient.query(publicPackageQuery(params.token)),
  component: PortalRoute,
  errorComponent: PortalUnavailable,
});
function PortalRoute() {
  const { token } = Route.useParams();
  return (
    <QueryClientProvider client={publicQueryClient}>
      <PackagePortal token={token} />
    </QueryClientProvider>
  );
}
function PortalUnavailable() {
  return (
    <main className="max-w-lg mx-auto p-8">
      <h1 className="text-xl mb-3">
        {t({ en: 'Package unavailable', nb: 'Pakken er utilgjengelig' })}
      </h1>
      <p>
        {t({
          en: 'This link is unavailable, expired or revoked. Please contact the sender.',
          nb: 'Lenken er utilgjengelig, utløpt eller trukket tilbake. Kontakt avsenderen.',
        })}
      </p>
    </main>
  );
}
